<ng-container [ngSwitch]="policiesType">
  <ng-container *ngSwitchCase="policiesDetailType.AUTOS">
    <ng-container *ngTemplateOutlet="autosPolicies"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="policiesDetailType.BUSES">
    <ng-container *ngTemplateOutlet="busesPolicies"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="policiesDetailType.FLIGHTS">
    <ng-container *ngTemplateOutlet="airOrPackagePolicies; context: { isPackagePolicies: false }"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="policiesDetailType.HOTELS">
    <ng-container *ngTemplateOutlet="hotelsPolicies"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="policiesDetailType.PACKAGES">
    <ng-container *ngTemplateOutlet="airOrPackagePolicies; context: { isPackagePolicies: true }"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="policiesDetailType.FLIGHTS_BY_SECTOR">
    <ng-container *ngTemplateOutlet="airBySectorPolicies; context: { isPackagePolicies: false }"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="policiesDetailType.ACTIVITIES">
    <ng-container *ngTemplateOutlet="activitiesPolicies"></ng-container>
  </ng-container>
</ng-container>

<ng-template #autosPolicies>
  <app-autos-policies
    [companyCode]="autoValidation?.VehicleOption?.Company?.Code"
    [titleClass]="titleClass">
  </app-autos-policies>
</ng-template>

<ng-template #busesPolicies>
  <app-buses-policies
    [titleClass]="titleClass">
  </app-buses-policies>
</ng-template>

<ng-template #airOrPackagePolicies let-isPackagePolicies='isPackagePolicies'>
  <app-flights-policies
    [isMobile]="isMobile"
    [titleClass]="titleClass"
    [isPackagePolicies]="!!isPackagePolicies"
    [airValidation]="airValidation"
    [showFreeCancellation]="showFreeCancellation"
    [airTermsBySector]="airTermsBySector"
    [isUserHistory]="!isBookingView">
  </app-flights-policies>
  <ng-container *ngIf="!!isPackagePolicies">
    <ng-container *ngTemplateOutlet="hotelPoliciesData"></ng-container>
    <ng-container *ngTemplateOutlet="importantInformation"></ng-container>
  </ng-container>
</ng-template>

<ng-template #hotelsPolicies>
  <app-hotels-policies
    [hotelValidation]="hotelValidation"
    [titleClass]="titleClass"
    [isUserHistory]="!isBookingView">
  </app-hotels-policies>
  <ng-container *ngTemplateOutlet="hotelPoliciesData"></ng-container>
  <ng-container *ngTemplateOutlet="importantInformation"></ng-container>
</ng-template>

<ng-template #airBySectorPolicies let-isPackagePolicies='isPackagePolicies'>
  <app-flights-by-sector-policies
    [isMobile]="isMobile"
    [titleClass]="titleClass"
    [isPackagePolicies]="!!isPackagePolicies"
    [airValidation]="airValidation"
    [showFreeCancellation]="showFreeCancellation"
    [isBookingView]="isBookingView"
    [isUserHistory]="!isBookingView">
  </app-flights-by-sector-policies>
</ng-template>

<ng-template #hotelPoliciesData>
  <app-hotels-policies-data
    [hotelValidation]="hotelValidation"
    [isUserHistory]="!isBookingView">
  </app-hotels-policies-data>
</ng-template>

<ng-template #importantInformation>
  <app-hotels-policies-important
    [hotelValidation]="hotelValidation"
    [titleClass]="titleClass"
    [isUserHistory]="!isBookingView">
  </app-hotels-policies-important>
</ng-template>

<ng-template #activitiesPolicies>
  <app-activities-policies
    [validation]="activitiesValidation"
    [titleClass]="titleClass"
    [isUserHistory]="!isBookingView">
  </app-activities-policies>
</ng-template>
